module.exports = __webpack_public_path__ + "202408221624/img/animation_shengqi.b7c86611.png";